import type { SVGProps } from 'react';
const SvgTablePicnic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.36 20.384c-.219.508-.82.75-1.345.541a.99.99 0 0 1-.558-1.304l1.405-3.283h2.234l-1.732 4.05zm17.188-.767a.984.984 0 0 1-.559 1.304c-.529.208-1.13-.03-1.345-.542l-1.731-4.05h2.234l1.405 3.284zM20.218 5c.572 0 1.032.446 1.032 1s-.46 1-1.031 1H17.15l2.281 5.333h3.537c.571 0 1.031.446 1.031 1 0 .555-.46 1-1.031 1H3.03c-.571 0-1.031-.445-1.031-1s.46-1 1.031-1h3.537L8.849 7H5.781C5.21 7 4.75 6.554 4.75 6s.46-1 1.031-1zM8.803 12.333h8.396L14.916 7H11.08l-2.281 5.333z"
    />
  </svg>
);
export default SvgTablePicnic;
